@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteContentGuide {

  .head {
    padding-top: 25px;
    margin-bottom: 25px;
    display: flex;
    align-items: center;
    justify-content: center;

    .whiteShadow {
      width: 239px;
      height: 124px;
      position: absolute;
      background: #ffffff58;
      filter: blur(100px);
      top: -77px;
      left: calc(50% - 120px)
    }

    .title {
      color: var(--white);
      font-size: 36px;
      text-align: center;
      max-width: 900px;

      @include texts.font("bold");
    }

    .loader {
      height: 50px;
      position: relative;
      width: 400px;
    }
  }

  .white {
    padding: 0 !important;

    .loader {
      height: 400px;
      position: relative;
      width: 100%;
    }

    .empty {
      min-height: 400px;

      .emptyIcon {
        height: 150px;
        width: 150px;

        @include icons.ico("3d-learning");
      }

      div[emptytext] {
        font-size: 22px;

        @include texts.font("semi-bold");
      }
    }
  }

  @media (max-width: 480px) {
    .head {
      padding-top: 0px;
      margin-bottom: 0px;

      .title {
        width: calc(100% - 30px);
        font-size: 24px;
      }
    }

    .white {
      margin-top: 40px !important;
    }
  }
}